<div class="init-match-container">
    <h2>Iniciar Partido</h2>
    <div class="info-match">
        <div><strong>{{match.player1?.playerName}}</strong> vs <strong>{{match.player2?.playerName}}</strong></div>
        <div>Categoria: <strong>{{match.category}}</strong></div>
        <div>Código: <strong>{{match.code}}</strong></div>
    </div>
    <div *ngIf="match.code" class="qr">
        <ngx-qrcode-styling 
        [config]="config"
        [template]="config.template"
        >
        </ngx-qrcode-styling>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="fill">
            <mat-label>Cancha</mat-label>
            <input matInput formControlName="court" />
        </mat-form-field>

        <div class="buttons">
            <button matButton="filled" type="submit" [disabled]="form.invalid">Guardar</button>
            <button matButton="outlined" type="button" (click)="exit()">Salir</button>
        </div>
    </form>
</div>